import './index.css';
import 'react-toastify/dist/ReactToastify.css';
import './locals/i18next';

// Disable browser's automatic scroll restoration — we handle it manually.
// Must be set synchronously before React mounts, otherwise the browser can
// override our restored scroll position after a back/forward navigation.
if ('scrollRestoration' in history) {
  history.scrollRestoration = 'manual';
}

import React, { Suspense } from 'react';

import App from './App.jsx';
import { HelmetProvider } from 'react-helmet-async';
import MetaPixel from './components/MetaPixel/MetaPixel.jsx';
import { Provider } from 'react-redux';
import ReactDOM from 'react-dom/client';
import { Spinner } from './components/Spinner/index.jsx';
import { ToastContainer } from 'react-toastify';
import store from './store/store';

ReactDOM.createRoot(document.getElementById('root')).render(
  <React.StrictMode>
    <>
      <Suspense fallback={<Spinner />}>
        <HelmetProvider>
          <Provider store={store}>
            <MetaPixel />
            <App />
          </Provider>
        </HelmetProvider>
      </Suspense>

      <ToastContainer position='top-center' autoClose={2000} />
    </>
  </React.StrictMode>
);
